export default __webpack_public_path__ + "img/4938d5d639e9b2081e2e645b43f8d99b.png";